import { Portal, Select as ChakraSelect, SelectRootProps } from '@chakra-ui/react'

export interface ISelectProps extends SelectRootProps {
    label?: React.ReactNode
    placeholder?: string
}

export const Select = ({ children, label, placeholder = 'Select framework', ...rest }: ISelectProps) => {
    return (
        <ChakraSelect.Root {...rest}>
            <ChakraSelect.HiddenSelect />
            <ChakraSelect.Label>{label}</ChakraSelect.Label>
            <ChakraSelect.Control>
                <ChakraSelect.Trigger>
                    <ChakraSelect.ValueText placeholder={placeholder} />
                </ChakraSelect.Trigger>
                <ChakraSelect.IndicatorGroup>
                    <ChakraSelect.Indicator />
                </ChakraSelect.IndicatorGroup>
            </ChakraSelect.Control>
            <Portal>
                <ChakraSelect.Positioner>
                    <ChakraSelect.Content>{children}</ChakraSelect.Content>
                </ChakraSelect.Positioner>
            </Portal>
        </ChakraSelect.Root>
    )
}

export const SelectItem = ChakraSelect.Item
